import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LifeBuoy, Mail, MessageSquare, Scale, ShieldCheck } from 'lucide-react';
import { SocialLinks } from '@/components/SocialLinks';
import { useLocalizedName } from '@/lib/useLocalizedName';
import { useContactLinks, useSite } from '@/lib/useSite';

/**
 * Shown to every role, signed in or not. Three things belong here and nowhere
 * else: who owns the product, how to reach a human, and where the manual is.
 * A committee treasurer who cannot find any of those stops using the tool.
 */
export function SiteFooter() {
  const { t } = useTranslation();
  const localized = useLocalizedName();
  const { settings } = useSite();
  const contact = useContactLinks();
  const year = new Date().getFullYear();
  const appName = localized(settings.appNameEn, settings.appNameAr);

  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div>
          <b>{appName}</b>
          <p>{localized(settings.taglineEn, settings.taglineAr) || t('footer.tagline')}</p>
        </div>

        <nav aria-label={t('footer.help')}>
          <span>{t('footer.help')}</span>
          {/*
            رابطان لا ثلاثة.
            --------------
            «مركز الدعم» يشرح كيف يُستعمل المنتج، و«تواصل معنا» يفتح
            نموذجاً يكتب فيه الزائر. وكان بينهما ثالث يقود إلى فقرة
            «تواصل» داخل صفحة الشرح — نفس الوجهة الأولى باسم الثانية،
            فيضغطه من يريد أن يكتب فيجد نفسه يقرأ.
          */}
          <Link to="/support">
            <LifeBuoy size={14} aria-hidden /> {t('footer.supportCentre')}
          </Link>
          <Link to="/contact">
            <MessageSquare size={14} aria-hidden /> {t('footer.contactUs')}
          </Link>
          {contact.social.length > 0 && <SocialLinks links={contact.social} />}
        </nav>

        <nav aria-label={t('footer.legal')}>
          <span>{t('footer.legal')}</span>
          {/* مستندان مستقلّان، لا مرساة داخل صفحة الدعم. الرابط الذي
              ينزل بك إلى فقرة وسط دليل استخدام لا يصلح أن يكون المرجع
              القانوني الذي تحيل إليه. */}
          <Link to="/legal/terms">
            <Scale size={14} aria-hidden /> {t('footer.terms')}
          </Link>
          <Link to="/legal/privacy">
            <ShieldCheck size={14} aria-hidden /> {t('footer.privacy')}
          </Link>
          {contact.email && (
            <a href={contact.email}>
              <Mail size={14} aria-hidden /> {settings.supportEmail}
            </a>
          )}
        </nav>
      </div>

      <p className="site-footer__legal">{t('footer.rights', { year, name: appName })}</p>
    </footer>
  );
}
